import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import {OrganizerEdit, OrganizerReadOnly} from './OrganizerForm';
import dayjs from "dayjs";

export default function CompaniesPage({}: any) {
    return (
        <GenericCrudPage
            key='organizer-page'
            singularName='organizer'
            pageTitle='Organizers'
            resource='organizer'
            allowAdd={true}
            allowEdit={true}
            allowDelete={true}
            ReadOnlyComponent={OrganizerReadOnly}
            EditFormComponent={OrganizerEdit}
            tableColumns={[
                {
                    field: 'title',
                    headerName: 'Title',
                    width: 200,
                }
            ]}
            newPayload={{
                title: '',
                start: dayjs(),
                end: dayjs(),
                color: '',
            }}
            validateFn={(data: any) => {
                return [true, []];
            }}
        />
    );
}
